import { apiClient } from "lib/axios";

/**
 * Branch APIs are company-scoped by backend context.
 *
 * Rules:
 * - Do NOT send companyId.
 * - Backend derives active company from httpOnly cookie/company context.
 * - Backend enforces branch permissions.
 */

export const getBranches = async (params = {}) => {
  const { data } = await apiClient.get("/branches", { params });
  return data;
};

export const getBranchById = async (id) => {
  const { data } = await apiClient.get(`/branches/${id}`);
  return data;
};

export const createBranch = async (body) => {
  const { companyId, ...cleanBody } = body || {};
  const { data } = await apiClient.post("/branches", cleanBody);
  return data;
};

export const updateBranch = async (id, body) => {
  const { companyId, ...cleanBody } = body || {};
  const { data } = await apiClient.put(`/branches/${id}`, cleanBody);
  return data;
};

export const archiveBranch = async (id) => {
  const { data } = await apiClient.delete(`/branches/${id}`);
  return data;
};
